import React, { useState } from 'react';
import Tabs from '@material-ui/core/Tabs/Tabs';
import Tab from '@material-ui/core/Tab/Tab';
import {
  getContributorsDefaultView,
  setContributorsDefaultView
} from 'common/services/contributors.service';
import * as TrackingService from 'common/services/tracking.service';
import { Flex } from './base/layout-components';
import ContributorsRoster from './ContributorsRoster';
import TeamsRoster from './TeamsRoster';
import { TRACKING } from 'common/constants/constants';

const TabPanel = props => {
  const { children, value, index, ...other } = props;

  if (value !== index) return null;

  return (
    <Flex
      width='100%'
      height='100%'
      component='div'
      role='tabpanel'
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {' '}
      {children}{' '}
    </Flex>
  );
};

const MultipleAvatars = ({
  teams,
  contributors,
  currentIteration,
  isRetrospect,
  dates,
  search,
  history,
  toggleModal,
  createTeam,
  toggleSnackBar,
  showLoader,
  getTeams,
  shouldHidePersonalInformationDashboard
}) => {
  const contributorViewToTabIndex = {
    individuals: 1,
    teams: 0
  };

  const [value, setValue] = useState(
    shouldHidePersonalInformationDashboard
      ? contributorViewToTabIndex.teams
      : contributorViewToTabIndex[getContributorsDefaultView()]
  );

  return (
    <>
      <Tabs
        value={value}
        indicatorColor='primary'
        textColor='primary'
        onChange={(e, newValue) => {
          setValue(newValue);
        }}
      >
        <Tab
          label='Teams'
          onClick={() => {
            TrackingService.logEvent(TRACKING.EVENTS.CLICK, {
              page: TRACKING.PAGES.DASHBOARD,
              page_tab: TRACKING.PAGE_TABS.CONTRIBUTORS,
              click_type: TRACKING.CLICK.TEAMS
            });
            setContributorsDefaultView('teams');
          }}
          data-cy='contributors-table-teams-tab-button'
        />
        {!shouldHidePersonalInformationDashboard && (
          <Tab
            label='Individuals'
            onClick={() => {
              TrackingService.logEvent(TRACKING.EVENTS.CLICK, {
                page: TRACKING.PAGES.DASHBOARD,
                page_tab: TRACKING.PAGE_TABS.CONTRIBUTORS,
                click_type: TRACKING.CLICK.INDIVIDUALS
              });
              setContributorsDefaultView('individuals');
            }}
            data-cy='contributors-table-individuals-tab-button'
          />
        )}
      </Tabs>

      <TabPanel
        value={value}
        index={0}
        {...(teams.length === 0 ? { margin: 'auto' } : {})}
      >
        <TeamsRoster
          toggleModal={toggleModal}
          toggleSnackBar={toggleSnackBar}
          createTeam={createTeam}
          dates={dates}
          contributors={contributors}
          isRetrospect={isRetrospect}
          teams={teams}
          currentIteration={currentIteration}
          history={history}
          search={search}
          showLoader={showLoader}
          getTeams={getTeams}
        />
      </TabPanel>
      <TabPanel
        value={value}
        index={1}
        {...(contributors.length === 0 ? { margin: 'auto' } : {})}
      >
        <ContributorsRoster
          dates={dates}
          isRetrospect={isRetrospect}
          contributors={contributors}
          currentIteration={currentIteration}
        />
      </TabPanel>
    </>
  );
};

export default MultipleAvatars;
